import { InputState } from '@/utils/inputState';
import { ReturnComponent } from '@/utils/reactTypes';
import { gql } from '@apollo/client';
import { License } from 'gql-types';

import {
    AxleAutoCompleteFieldProps,
    AxleAutocompleteField,
} from '../formFields/AxleAutocompleteField';
import { ClinicianOptionLabel } from './ClinicianOptionLabel';

export interface IClinicianOption {
    id: string;
    fullName: string;
    firstName: string;
    lastName: string;
    logoUrl: string | null;
    licenses: License[] | null;
}

export const ClinicianOptionFragment = gql`
    fragment ClinicianOptionFragment on Clinician {
        id
        fullName
        firstName
        lastName
        logoUrl
        licenses
    }
`;

export const OptionalClinicianSelector = ({
    enabled = true,
    inputState,
    options,
    ...rest
}: {
    enabled?: boolean;
    inputState: InputState<IClinicianOption | null>;
    options: IClinicianOption[];
} & Omit<
    AxleAutoCompleteFieldProps<string | null, IClinicianOption>,
    'inputState' | 'options' | 'optionToValue' | 'optionToLabel' | 'renderOption'
>): ReturnComponent => {
    return (
        <AxleAutocompleteField<IClinicianOption, IClinicianOption | null>
            {...rest}
            enabled={enabled}
            inputState={inputState}
            options={options}
            handleNullValue={() => {
                inputState.setInputState(null);
            }}
            optionToValue={(clinician) => clinician}
            optionToLabel={(clinician) => clinician.fullName}
            renderOption={(clinician) => <ClinicianOptionLabel option={clinician} />}
            displayMissingOptionValue={true}
        />
    );
};
